import React from 'react'
import {Icon} from '@chakra-ui/react'

const SendIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" id="send" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5462 21.2545L11.5545 21.26L14.2453 17.2238L22.2 20.6636L24 1.46362L0 11.0636L8.78724 14.8635L9.57091 20.3492C9.59967 20.5505 9.63778 20.7205 9.69403 20.8703C9.85971 21.3117 10.1275 21.6421 10.7471 21.6264C11.1398 21.6164 11.3802 21.4745 11.5462 21.2545ZM13.42 14.6651L20.4474 17.704L21.6789 4.56858L5.25963 11.1363L9.56509 12.9981L21.6021 4.66479L13.42 14.6651Z"
                fill="black"
            />
        </Icon>
    )
}

export default SendIcon
